var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
import { OptionItem } from '../../../../diagram/utils/option-item';
import * as _ from 'lodash';
import { RelationalOperator } from './relational-operator';
var RelationalOperatorOptionService = /** @class */ (function () {
    function RelationalOperatorOptionService() {
        this.optionList = [
            new OptionItem(RelationalOperator.LessThan, '<'),
            new OptionItem(RelationalOperator.GreaterThan, '>'),
            new OptionItem(RelationalOperator.LessOrEqual, '<='),
            new OptionItem(RelationalOperator.GreaterOrEqual, '>='),
            new OptionItem(RelationalOperator.Equal, '=='),
            new OptionItem(RelationalOperator.NotEqual, '!=')
        ];
    }
    RelationalOperatorOptionService.prototype.getOptions = function () {
        return this.optionList;
    };
    RelationalOperatorOptionService.prototype.getOptionNameByKey = function (key) {
        // eslint-disable-next-line eqeqeq
        var option = _.find(this.optionList, function (s) { return s.key == key; });
        return option ? option.name : '';
    };
    RelationalOperatorOptionService = __decorate([
        Injectable()
    ], RelationalOperatorOptionService);
    return RelationalOperatorOptionService;
}());
export { RelationalOperatorOptionService };
